import service from '@/utils/request';
// 新增公告
export function addNotice(param) {
    return service.request({
        method: 'POST',
        url: `/app/notice/add`,
        data: param
    })
}

// 分页公告
export function getNoticeList(param) {
    return service.request({
        method: 'POST',
        url: `/app/notice/noticeList`,
        data: param
    })
}

// 删除
export function delNotice(param) {
    return service.request({
        method: 'POST',
        url: `/app/notice/del`,
        data: param
    })
}

// 获取公告详情
export function noticeById(param) {
    return service.request({
        method: 'POST',
        url: `/app/notice/noticeById`,
        data: param
    })
}
// 公告上传图片
export function uploadImgs(param) {
    return service.request({
        method: 'POST',
        url: `/app/common/upload`,
        data: param
    })
}

// 公告上传图片
export function editNotice(param) {
    return service.request({
        method: 'POST',
        url: `/app/notice/edit`,
        data: param
    })
}

// 中标公告
export function winBidNoticeList(param) {
    return service.request({
        method: 'POST',
        url: `/app/winBidNotice/winBidNoticeList`,
        data: param
    })
}

// 获取中标公告详情
export function winBidNoticeById(param) {
    return service.request({
        method: 'POST',
        url: `/app/winBidNotice/winBidNoticeById`,
        data: param
    })
}

// 获取采购寻源列表
export function sourcNoticeList(param) {
    return service.request({
        method: 'POST',
        url: `/app/sourcNotice/sourcNoticeList`,
        data: param
    })
}

// 获取协议富文本
export function agreementlist(param) {
    return service.request({
        method: 'POST',
        url: `/app/agreement/list`,
        data: param
    })
}
//
export function addAgreement(param) {
    return service.request({
        method: 'POST',
        url: `/app/agreement/add`,
        data: param
    })
}
export function editAgreement(param) {
    return service.request({
        method: 'POST',
        url: `/app/agreement/edit`,
        data: param
    })
}

export function sourcNoticeById(param) {
    return service.request({
        method: 'POST',
        url: `/app/sourcNotice/sourcNoticeById`,
        data: param
    })
}
















